/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { ajax, AjaxRequest, AjaxResponse } from 'rxjs/ajax';
import { environment } from '../../../../environments/environment';
import { from, Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { set as _set } from 'lodash';
import { fetchAuthSession, AuthSession } from 'aws-amplify/auth';

@Injectable({
    providedIn: 'root',
})
export class BaseRequester {
    constructor() {}

    protected internalPostRequest<T>(
        endpoint: string,
        requestPayload: T,
        responseType?: string,
    ): Observable<AjaxResponse> {
        return from(fetchAuthSession()).pipe(
            take(1),
            switchMap((session: AuthSession) => {
                const ajaxRequest: AjaxRequest = {
                    url: endpoint,
                    body: JSON.stringify(requestPayload),
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-api-key': environment.lsiEndpointApiKey,
                    },
                };
                if (responseType) {
                    ajaxRequest.responseType = responseType;
                }

                const jwtToken = session.tokens?.idToken?.toString();
                if (jwtToken && ajaxRequest.headers) {
                    _set(
                        ajaxRequest.headers,
                        'Authorization',
                        `Bearer ${jwtToken}`,
                    );
                }

                return ajax(ajaxRequest);
            }),
        );
    }

    // The internal lambdas answer 200 with an { errorType, errorMessage }
    // envelope when they throw — surface that as an Error, else unwrap the
    // body.
    protected serviceHandler<T>(response: AjaxResponse): T {
        if (response.response.errorMessage) {
            throw new Error(
                `[${response.response.errorType}]: ${response.response.errorMessage}`,
            );
        }
        return response.response;
    }
}

export interface UnifiedQueryRequest {
    operation: 'scan' | 'query';
    parameter: any;
}
